const REGISTERED_MSG = ' has already been registered for this division.';

const isRegisteredInDivision = (registration, divisionId) => {
    return !!registration?.registeredDivisions?.some(
        d => String(d.divisionId) === String(divisionId),
    );
};

export const getConflictMessages = ({
    lookupResults,
    selectedMemberId,
    selectedPartnerMemberId,
    selectedDivisionId,
    selectedPlayerName,
    selectedPartnerPlayerName,
}) => {
    const empty = { playerId: null, partnerPlayerId: null, divisionId: null };

    if (!selectedMemberId || !selectedDivisionId || !lookupResults || Object.keys(lookupResults).length === 0) {
        return empty;
    }

    const primaryReg = lookupResults[selectedMemberId];
    const isPlayerConflict = isRegisteredInDivision(primaryReg, selectedDivisionId);

    const partnerReg = selectedPartnerMemberId ? lookupResults[selectedPartnerMemberId] : null;
    const isPartnerConflict = !!partnerReg &&
        primaryReg !== partnerReg &&
        isRegisteredInDivision(partnerReg, selectedDivisionId);

    if (!isPlayerConflict && !isPartnerConflict) {
        return empty;
    }

    const conflictedNames = [];
    const result = { ...empty };

    if (isPlayerConflict) {
        const name = selectedPlayerName || 'Player';
        result.playerId = `${name}${REGISTERED_MSG}`;
        conflictedNames.push(name);
    }
    if (isPartnerConflict) {
        const name = selectedPartnerPlayerName || 'Partner';
        result.partnerPlayerId = `${name}${REGISTERED_MSG}`;
        conflictedNames.push(name);
    }

    const namesText = conflictedNames.length === 2
        ? `${conflictedNames[0]} and ${conflictedNames[1]} have`
        : `${conflictedNames[0]} has`;
    result.divisionId = `${namesText} already been registered for this division.`;

    return result;
};
